import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class SliderComponent extends ThemeComponent {

    @Ref() slider!: HTMLUListElement;
    @Ref({ required: false }) sliderItems!: HTMLLIElement[];
    @Ref({ required: false }) prevButton!: HTMLButtonElement;
    @Ref({ required: false }) nextButton!: HTMLButtonElement;

    protected sliderItemsToShow: HTMLLIElement[]|[] = [];
    protected sliderFirstItemNode: HTMLLIElement|null = null;
    protected currentPage: number = 1;
    protected slidesPerPage: number = 1;
    protected totalPages: number = 1;
    protected slideScrollPosition: number = 0;
    protected sliderItemOffset: number = 0;

    init() {

        if (this.sliderItems.length === 0) {
            return;
        }

        this.sliderFirstItemNode = this.sliderItems[0];

        if (this.prevButton && this.nextButton) {
            this.initDirectionButtons();
        }

        const resizeObserver = new ResizeObserver((entries) => this.initPages());
        resizeObserver.observe(this.slider);

        this.$listen(this.slider, 'scroll', (event) => {
            this.update();
        });

        this.slider.scrollLeft = 0;
    }

    protected initPages() {

        this.sliderItemsToShow = Array.from(this.sliderItems).filter(
            (element) => element.clientWidth > 0
        );

        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

        this.slidesPerPage = Math.floor(
            (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
        );

        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

        if (this.nextButton) {
            if (this.totalPages === 1) {
                this.nextButton.setAttribute('disabled', 'disabled');
            } else if (this.currentPage !== this.totalPages) {
                this.nextButton.removeAttribute('disabled');
            }
        }

    }

    private update() {

        if (!this.slider || !this.nextButton) {
            return;
        }

        const previousPage = this.currentPage;
        this.currentPage = Math.ceil(this.slider.scrollLeft / this.sliderItemOffset) + 1;

        if (this.currentPage != previousPage) {
            this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
                currentPage: this.currentPage,
                currentElement: this.sliderItemsToShow[this.currentPage - 1]
            }}));
        }

        if (this.prevButton) {
            if (this.currentPage === 1) {
                this.prevButton.setAttribute('disabled', 'disabled');
            } else {
                this.prevButton.removeAttribute('disabled');
            }
        }

        if (this.nextButton) {
            if (this.currentPage === this.totalPages) {
                this.nextButton.setAttribute('disabled', 'disabled');
            } else {
                this.nextButton.removeAttribute('disabled');
            }
        }

    }

    private initDirectionButtons() {
        this.$listen(this.prevButton, 'click', (event) => {
            this.onDirectionClick(event);
        });
        this.$listen(this.nextButton, 'click', (event) => {
            this.onDirectionClick(event);
        });
    }

    private onDirectionClick(event: MouseEvent) {

        if (!event.currentTarget) {
            return;
        }

        const clickedButton = event.currentTarget as HTMLButtonElement;
        const isFirstSlide = this.currentPage === 1;
        const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
        const clientWidth = this.sliderFirstItemNode === null ? 0 : this.sliderFirstItemNode.clientWidth;

        this.slideScrollPosition = clickedButton.name === 'next' ?
            this.slider.scrollLeft + (1 * this.sliderItemOffset) :
            this.slider.scrollLeft - (1 * this.sliderItemOffset);

        this.slider.scrollTo({
            left: this.slideScrollPosition
        });
    }
}
